<div class="modal-body form-modal-body">
  <div class="skylark-modal-header skylark-modal-header--reject">
    <h4>Reject Competency</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>

  <div class="competency-modal-preview" *ngIf="competency">
    <div class="competency-modal-preview__header">{{ competency.type }}</div>
    <div class="competency-modal-preview__body">
      <div class="competency-card__badge competency-modal-preview__badge"
        [attr.style]="'--competency-badge-color: ' + (competency.name | competencyBadgeColor) | safestyle">
        {{ competency.name }}
      </div>
      <div class="competency-modal-preview__detail" *ngIf="competency.oem">
        <span class="competency-card__label">OEM:</span>
        <span>{{ competency.oem }}</span>
      </div>
      <div class="competency-modal-preview__detail" *ngIf="competency.model">
        <span class="competency-card__label">Model:</span>
        <span>{{ competency.model }}</span>
      </div>
      <div class="competency-modal-preview__detail" *ngIf="competency.rating">
        <span class="competency-card__label">Rating:</span>
        <span>{{ competency.rating }}</span>
      </div>
    </div>
    <div class="competency-modal-preview__status competency-card__status--unverified">
      Unverified<ng-container *ngIf="competency.expiryDate">: {{ competency.expiryDate | date: 'MMM dd, y' }}</ng-container>
    </div>
  </div>

  <div class="row form-row mt-3">
    <div class="col-md-12">
      <div class="form-group">
        <label class="modal-label"><b>Reason for Rejection</b> <span class="required-text">(required)</span></label>
        <textarea
          class="form-control"
          style="height: 120px; max-height: none; resize: vertical;"
          placeholder="Enter reason for competency rejection..."
          maxlength="300"
          [(ngModel)]="rejectionReason">
        </textarea>
        <small class="form-text text-muted text-right">300 characters maximum</small>
      </div>
    </div>
  </div>

  <p-footer>
    <button type="button" class="btn btn-round btn-outline-default" [disabled]="saveInProgress" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-round btn-danger" [disabled]="saveInProgress || !rejectionReason.trim()" (click)="reject()">Reject</button>
  </p-footer>
</div>
